import React from 'react'
import { InElementSlot } from 'uiComponents/navigation/sectionTabsSlot'
import './tableHeaderSlot.scss'

export const CODES_TABLE_HEADER_SLOT_ID = 'codes-table-header'

interface InCodesTableHeaderProps {
    children: React.ReactNode
}

export function InCodesTableHeader({ children }: InCodesTableHeaderProps) {
    return <InElementSlot slotId={CODES_TABLE_HEADER_SLOT_ID}>{children}</InElementSlot>
}

export default InCodesTableHeader
